function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("mask", {
  id: "time-entry-added_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 21,
  height: 21
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h21v21H0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 15.5,
  r: 7,
  fill: "#000"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#time-entry-added_svg__a)",
  fill: "#8F90A6"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.5.5a8 8 0 100 16 8 8 0 000-16zm0 1.4a6.6 6.6 0 110 13.2 6.6 6.6 0 010-13.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 4.2a.7.7 0 01.7.7v3.6h2.6a.7.7 0 110 1.4H8.5a.7.7 0 01-.7-.7V4.9a.7.7 0 01.7-.7z"
}));

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "time-entry-added_svg__b",
  maskUnits: "userSpaceOnUse",
  x: 8,
  y: 8,
  width: 14,
  height: 14
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 15.5,
  r: 5.5,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 12.2,
  width: 1,
  height: 6.6,
  rx: 0.5,
  fill: "#000"
}), /*#__PURE__*/React.createElement("rect", {
  x: 12.2,
  y: 15,
  width: 6.6,
  height: 1,
  rx: 0.5,
  fill: "#000"
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 15.5,
  r: 5.5,
  fill: "#8F90A6",
  mask: "url(#time-entry-added_svg__b)"
});

function SvgTimeEntryAdded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgTimeEntryAdded;